import { render, staticRenderFns } from "./exportDeclarations.vue?vue&type=template&id=66018dce&scoped=true"
import script from "./exportDeclarations.vue?vue&type=script&lang=js"
export * from "./exportDeclarations.vue?vue&type=script&lang=js"
import style0 from "./exportDeclarations.vue?vue&type=style&index=0&id=66018dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66018dce",
  null
  
)

export default component.exports